import React from 'react';
import { QHeading, QStack } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import UserInfo from '../../../components/FormComponents/UserInfo';

type GeneralSectionProps = {
  inviteIsPending: boolean;
  showProfileFields: boolean;
};

const GeneralSection = ({ inviteIsPending, showProfileFields }: GeneralSectionProps) => {
  const { t } = useTranslation();
  return (
    <QStack direction={['column']}>
      <QHeading fontWeight="bold" size="md">
        {t('editUser.general')}
      </QHeading>
      <UserInfo inviteIsPending={inviteIsPending} showProfileFields={showProfileFields} />
    </QStack>
  );
};

export default GeneralSection;
